import Cookies from "js-cookie";
import { logger } from "@tecma/logs-fe";
import psl from "psl";

export const logout = (history, store) => {
  try {
    let domain;
    if (window.location.hostname !== "localhost") {
      const pslUrl = psl.parse(window.location.hostname);
      domain = pslUrl.domain;
    }

    const cookieOptions = domain ? { domain } : undefined;
    Cookies.remove("jwt", cookieOptions);
    Cookies.remove("refreshToken", cookieOptions);
    Cookies.remove("expiresIn", cookieOptions);
    Cookies.remove("vendorId", cookieOptions);
  } catch (e) {
    logger.error("Error during logout operations..", e);
  }
  store?.clearLoggedUser();
  if (history) {
    history.push("/login");
  }
};
